import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, message, Select} from 'antd'
import azureKeyVaultAPI from '../../../apis/azureKeyVaultAPI'
import {withTranslation} from 'react-i18next'

class EditModal extends Component {
  formRef = React.createRef()
  state = {
    azureApplicationList: []
  }

  componentDidMount() {
    this.getInfoAction()
    this.getAzureApplication()
  }

  getInfoAction = () => {
    const {id} = this.props
    azureKeyVaultAPI.getInfoAction(id).then(res => {
      this.formRef.current.setFieldsValue({
        keyVaultName: res.data.data.keyVaultName,
        keyVaultUrl: res.data.data.keyVaultUrl,
        azureAppRegistrationId: res.data.data.azureAppRegistrationId,
      })
    })
  }

  getAzureApplication = () => {
    azureKeyVaultAPI.getApplicationNameList().then(res => {
      this.setState({
        azureApplicationList: res.data.data
      })
    })
  }

  handleOk = () => {
    const {handleCancel, handleSearch, id} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        id: id,
        keyVaultName: fieldsValue.keyVaultName,
        keyVaultUrl: fieldsValue.keyVaultUrl,
        azureAppRegistrationId: fieldsValue.azureAppRegistrationId,
      }

      azureKeyVaultAPI.saveKeyVault(params).then(res => {
        handleCancel('editModalVisible')
        handleSearch()
        message.success('Success!')
      })
    }).catch(err => { })
  }

  render() {
    const {editModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.edit`)} ${t(`azureKeyVault.keyVault`)}`}
          width="70%"
          closable={true}
          visible={editModalVisible}
          onCancel={() => { handleCancel('editModalVisible') }}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="formRef" layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="keyVaultName" label={t(`azureKeyVault.keyVaultName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`azureKeyVault.keyVaultName`)}`,
                             pattern: new RegExp(/^[^&|;\\\s]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="keyVaultUrl" label={t(`general.pleaseEnter`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`azureKeyVault.keyVaultURL`)}`,
                             pattern: new RegExp(/^[^&|;\\\s]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8} span={8}>
                <Form.Item name="azureAppRegistrationId" label={t(`azureKeyVault.azureApp`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`azureKeyVault.azureApp`)}`,
                             pattern: new RegExp(/^[^&|;\\\s]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {
                      this.state.azureApplicationList.length > 0 && this.state.azureApplicationList.map((item) => {
                        return (
                          <Select.Option key={item.id} value={item.id}>{item.applicationName}</Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(EditModal)
